import {
  GET_TRANSFER_TYPE_LIST_SUCCESS,
  GET_TRANSFER_TYPE_LIST_FAILED,
  RESET_GET_TRANSFER_TYPE_LIST,
  LOADING_GET_TRANSFER_TYPE_LIST,
  NETWORK_ERROR_GET_TRANSFER_TYPE_LIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_TRANSFER_TYPE_LIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
      };
    case GET_TRANSFER_TYPE_LIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
      };
    case GET_TRANSFER_TYPE_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
      };
    case NETWORK_ERROR_GET_TRANSFER_TYPE_LIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
      };
    case RESET_GET_TRANSFER_TYPE_LIST:
      return (state = initialState);
    default:
      return state;
  }
};
